import services from 'services/services';
import * as types from '../types';
import { setRequestUrl } from 'store/actions';

// Import helpers
import {
	checkFetchErrors,
	queryParams
} from '../helpers_actions/convert_helpers';

// Import variables
import { TABLE_LENGTH } from 'components/helpers/table';

// ******************** FETCH BANNERS - TABLE DATA ********************
export const fetchBanners = (options) => async (dispatch, getState) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_BANNERS_LOADING,
			payload: true
		});

		const {
			banners: {
				table: {
					columns,
					options: {
						filters: { filterUrlQuery },
						startIndex: startTableIndex,
						page
					}
				}
			}
		} = getState();

		const startIndex =
			options.page === page ? startTableIndex : options.startIndex;

		const url = `/section/banners/list?${filterUrlQuery}${queryParams(
			options,
			TABLE_LENGTH,
			columns,
			startIndex
		)}`;

		const { data } = await services.get(url);

		// Calculate pages
		const pages = Math.ceil(data.recordsFiltered / TABLE_LENGTH);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_BANNERS_SUCCESS,
			payload: { ...data, pages, page: options.page, startIndex }
		});

		// save request url in redux
		setRequestUrl(url)(dispatch);
	} catch (error) {
		dispatch({
			type: types.FETCH_BANNERS_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** DELETE BANNER ********************
export const deleteBanner = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.DELETE_BANNER_LOADING,
			payload: true
		});

		await services.delete(`/section/banners/${id}`);
		// Dispatch an action with data
		dispatch({
			type: types.DELETE_BANNER_SUCCESS,
			payload: true
		});
	} catch (error) {
		// Dispatch an action with error set to true
		dispatch({
			type: types.DELETE_BANNER_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** SET BANNERS QUERY ********************
export const setBannersQuery = (query) => ({
	type: types.SET_BANNERS_SEARCH_QUERY,
	payload: query
});
